<template>
  <div>
    <kst-warning class="mb-4" :items="detailsWarning"/>
    <kst-input field="Date" :data="data" :catalog="Catalog"/>
    <kst-input field="WarehouseID" :data="data" :catalog="Catalog"
      :options="warehouseOptions" @input="handleInput"
      :disabled="userItems.length > 0"
    />
    <kst-input load-on-focus field="IsAutoNumber" :data="data" :catalog="Catalog">
      <template #right>
        <kst-input addons expanded field-only
          v-show="!data.IsAutoNumber"
          field="AdjNumber" :data="data" :catalog="Catalog"
          :customValidations="numberValidations"
        />
      </template>
    </kst-input>
    <kst-input field="Comment" :data="data" :catalog="Catalog"/>
    <input type="submit" value="Cari" class="is-hidden">
  </div>
</template>
<script>
import Catalog from "../SpecialPriceAdjCatalog.js";
import Info from "../SpecialPriceAdjInfo.js";
import Model from "../SpecialPriceAdjModel.js";
import SearchMixin from "@/mixins/SearchMixin.js";

export default {
  mixins: [SearchMixin],
  props: {
    data: Object,
    userItems: Array,
    warehouseOptions: Object
  },
  computed: {
    detailsWarning() {
      return [
        Info.Message.New_Warehouse,
        Info.Message.New_Date
      ];
    },
    numberValidations() {
      return Model.validationNumber(this.data);
    }
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  }),
  created() {
    this.initSearch(this.data, this.submit);
  },
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Submit);
    }
  }
}
</script>